import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A4 document frame. On screen: 21cm × 29.7cm shadow-box with visible
 * page boundaries when content overflows one page. In print: occupies
 * the full page with margins controlled by `@page` rules in the SPA's
 * index.css.
 *
 * The header and footer slots are rendered with the special CSS classes
 * `pdf-repeat-header` / `pdf-repeat-footer` which the print stylesheet
 * positions `position: fixed` at top/bottom of every printed page (per
 * ADR-0008).
 */
export function TemplateDocument(props) {
    return (_jsxs("article", { id: "pdf-preview-content", className: "mx-auto bg-white text-stone-800 shadow-lg shadow-stone-300/50 print:shadow-none", style: {
            width: '21cm',
            minHeight: '29.7cm',
            padding: '2cm 2.2cm 2.5cm 2.2cm',
            fontFamily: 'Georgia, "Times New Roman", serif',
        }, children: [props.header && (_jsx("div", { className: "pdf-repeat-header mb-4 border-b border-stone-300 pb-1.5", children: props.header })), _jsx("div", { className: "text-[11px] leading-relaxed print:text-[12px]", children: props.children }), props.footer && (_jsx("div", { className: "pdf-repeat-footer mt-6 border-t border-stone-300 pt-1", children: props.footer }))] }));
}
/**
 * Forces a page break in print. Invisible on screen (a thin dashed line
 * appears in dev mode so the author knows where the break is).
 */
export function PageBreak() {
    return (_jsx("div", { className: "my-3 border-t border-dashed border-stone-300 text-center text-[9px] uppercase tracking-[0.2em] text-stone-400 print:border-none print:text-transparent", style: { breakAfter: 'page' }, "data-no-print": true, children: "\u2014 sidbrytning \u2014" }));
}
/**
 * Prevents children from being split across a page break. Use for
 * signature blocks, short clauses, table rows that must stay together.
 */
export function KeepTogether(props) {
    return (_jsx("div", { style: { breakInside: 'avoid', pageBreakInside: 'avoid' }, children: props.children }));
}
/**
 * Vertical spacing token. Maps to consistent gaps usable across templates.
 */
export function Spacer(props) {
    const map = {
        xs: 'h-1',
        sm: 'h-2',
        md: 'h-4',
        lg: 'h-6',
        xl: 'h-10',
    };
    return _jsx("div", { className: map[props.size ?? 'md'], "aria-hidden": true });
}
//# sourceMappingURL=TemplateDocument.js.map